export type DownloadDomAsPngOptions = {
  scale?: number;
  useCORS?: boolean;
};

/**
 * Renders an element to PNG via html2canvas and triggers a file download.
 */
export async function downloadDomElementAsPng(
  element: HTMLElement,
  filename: string,
  options: DownloadDomAsPngOptions = {},
): Promise<void> {
  const { scale = 2, useCORS = true } = options;
  const { default: html2canvas } = await import('html2canvas');
  const canvas = await html2canvas(element, { scale, useCORS });
  const url = canvas.toDataURL('image/png');
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
}
